import React, { FC } from 'react';

import { useInsuranceLabels } from '../../../Utils/Context/labelsContext';
import { Placeholder } from '../../../Partials/Placeholder';
import { DoctorBarStatus } from '../Types/types';

interface DoctorBarPricingProps {
  price?: number
  isAuthenticated: boolean;
  barState: DoctorBarStatus;
}

export const DoctorBarPricing: FC<DoctorBarPricingProps> = (props) => {
  const { price, isAuthenticated, barState } = props;

  const {
    labels
  } = useInsuranceLabels();

  return (
    <div className="doctorBar__price">
          <>
            <Placeholder loadingDone={barState !== 'loading'}>
              {barState === 'noFilters' && (
                <span className="doctorBar__placeholderText">
                  {labels.chooseTreatmentAndServiceLabel}
                </span>
              )}
            </Placeholder>
            {barState === 'withFilters' && (
              <div className='doctorBar__appointment'>
                <div className='doctorBar__appointmentPrice'>
                  <span>
                    <b>{labels.treatmentLabel}</b>
                  </span>
                  <span>
                    {price ? <>{labels.priceLabel} <b>{price},-</b> NOK</> : labels.priceUnavailableLabel}
                  </span>
                </div>
              </div>
            )}
          </>
    </div>
  )
};
